<template>
  <div style="width: 100%;height: 100%">
    <iframe
      src="https://www.pgyer.com/ezCULzXo"
      width="100%"
      height="100%"
      allowfullscreen
  />
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
